export const PMS_REGEX = /global[-|_]pms[-|_]special[-|_]/gi;
